export default __webpack_public_path__ + "static/media/bookmark1.6fa6cd96.png";